"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bubble = exports.Y_SHIFT = exports.X_SHIFT = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var keys_1 = tslib_1.__importDefault(require("lodash/keys"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var result_1 = tslib_1.__importDefault(require("lodash/result"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Overlay_1 = require("../Overlay");
var ARROW_DIRECTIONS = {
    ".. cc": "none",
    ".r .l|.. cl": "left",
    ".l .r|.. cr": "right",
    ".. t.": "top",
    ".. b.": "bottom",
    ".. .l": "left",
    ".. .r": "right",
};
// FIXME: hardcoded offsets for Indigo style
exports.X_SHIFT = 7;
exports.Y_SHIFT = 11;
// FIXME: constants are bad, we know :(
var ARROW_OFFSETS = {
    ".. cc": [0, 0],
    ".. tc": [0, exports.X_SHIFT],
    ".. bc": [0, -exports.X_SHIFT],
    ".. cl": [exports.X_SHIFT, 0],
    ".. cr": [-exports.X_SHIFT, 0],
    ".r tl": [exports.X_SHIFT, -exports.Y_SHIFT],
    ".l tr": [-exports.X_SHIFT, -exports.Y_SHIFT],
    ".r bl": [exports.X_SHIFT, exports.Y_SHIFT],
    ".l br": [-exports.X_SHIFT, exports.Y_SHIFT],
    ".. tl": [-exports.Y_SHIFT, exports.X_SHIFT],
    ".. tr": [exports.Y_SHIFT, exports.X_SHIFT],
    ".. bl": [-exports.Y_SHIFT, -exports.X_SHIFT],
    ".. br": [exports.Y_SHIFT, -exports.X_SHIFT],
};
/**
 * @internal
 */
var Bubble = /** @class */ (function (_super) {
    tslib_1.__extends(Bubble, _super);
    function Bubble(props) {
        var _this = _super.call(this, props) || this;
        _this.onAlign = function (alignment) {
            _this.setState({ optimalAlignPoints: alignment.align });
        };
        _this.arrowOffsets = tslib_1.__assign(tslib_1.__assign({}, props.arrowOffsets), ARROW_OFFSETS);
        _this.arrowDirections = tslib_1.__assign(tslib_1.__assign({}, props.arrowDirections), ARROW_DIRECTIONS);
        var alignPoints = _this.addOffsetToAlignPoints(cloneDeep_1.default(props.alignPoints));
        _this.state = {
            alignPoints: alignPoints,
            optimalAlignPoints: props.alignPoints[0].align,
        };
        return _this;
    }
    Bubble.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var propsChanged = !isEqual_1.default(this.props, nextProps);
        var alignmentChanged = !isEqual_1.default(this.state.optimalAlignPoints, nextState.optimalAlignPoints);
        return propsChanged || alignmentChanged;
    };
    Bubble.prototype.getClassnames = function () {
        var _a;
        return classnames_1.default((_a = {},
            _a[this.props.className] = !!this.props.className,
            _a[this.getArrowsClassname(this.state.optimalAlignPoints)] = true,
            _a["gd-bubble"] = true,
            _a.bubble = true,
            _a));
    };
    Bubble.prototype.getArrowsClassname = function (alignPoints) {
        var myAlignPoint = alignPoints.split(" ")[1];
        var direction = this.getArrowDirection(alignPoints);
        return "arrow-" + direction + "-direction arrow-" + myAlignPoint;
    };
    Bubble.prototype.getArrowDirection = function (alignPoints) {
        var key = keys_1.default(this.arrowDirections).find(function (arrowDirection) { return alignPoints.match(arrowDirection); });
        return this.arrowDirections[key] || "none";
    };
    Bubble.prototype.addOffsetToAlignPoints = function (alignPoints) {
        var _this = this;
        var arrowOffsets = this.arrowOffsets;
        var arrowOffsetsKeys = keys_1.default(arrowOffsets);
        var getKey = function (align, re) {
            return align.match(re) !== null;
        };
        return alignPoints.map(function (item) {
            var key = arrowOffsetsKeys.find(getKey.bind(_this, item.align));
            item.offset = item.offset || { x: 0, y: 0 };
            item.offset.x += arrowOffsets[key][0];
            item.offset.y += arrowOffsets[key][1];
            return item;
        }, this);
    };
    Bubble.prototype.render = function () {
        var arrowStyle = result_1.default(this.props, "arrowStyle", {});
        return (react_1.default.createElement(Overlay_1.Overlay, { className: this.props.overlayClassName, alignTo: this.props.alignTo, onAlign: this.onAlign, alignPoints: this.state.alignPoints, closeOnParentScroll: true, closeOnMouseDrag: true, closeOnOutsideClick: this.props.closeOnOutsideClick, ignoreClicksOn: this.props.ignoreClicksOn, ignoreClicksOnByClass: this.props.ignoreClicksOnByClass, onClose: this.props.onClose },
            react_1.default.createElement("div", { onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave, className: this.getClassnames() },
                react_1.default.createElement("div", { className: "bubble-content" },
                    react_1.default.createElement("div", { className: "helper" }),
                    react_1.default.createElement("div", { className: "arrow-position", style: arrowStyle },
                        react_1.default.createElement("div", { className: "arrow-border" }),
                        react_1.default.createElement("div", { className: "arrow" })),
                    react_1.default.createElement("div", { className: "content" }, this.props.children)))));
    };
    Bubble.defaultProps = {
        alignPoints: [
            {
                align: "bl tl",
            },
        ],
        alignTo: "body",
        arrowOffsets: {},
        arrowDirections: {},
        arrowStyle: {},
        className: "bubble-primary",
        closeOnOutsideClick: false,
        onClose: noop_1.default,
        onMouseEnter: noop_1.default,
        onMouseLeave: noop_1.default,
        overlayClassName: "",
    };
    // identifier for BubbleTrigger
    Bubble.identifier = "Bubble";
    return Bubble;
}(react_1.default.Component));
exports.Bubble = Bubble;
//# sourceMappingURL=Bubble.js.map